import { render, staticRenderFns } from "./notFundData.vue?vue&type=template&id=341973f6&scoped=true"
import script from "./notFundData.vue?vue&type=script&lang=js"
export * from "./notFundData.vue?vue&type=script&lang=js"
import style0 from "./notFundData.vue?vue&type=style&index=0&id=341973f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341973f6",
  null
  
)

export default component.exports